import { c as _c } from "react/compiler-runtime";
import debounce from 'lodash/debounce';
import { useEffect, useState } from 'react';
enum DEVICE_TYPES {
  IOS = 'ios',
  ANDROID = 'android',
}
const ANDROID_REGEX = /Android/i;
const IOS_REGEX = /iPhone|iPad|iPod/i;
const getCurrentDevice = () => {
  if (navigator) {
    if (IOS_REGEX.test(navigator.userAgent)) {
      return DEVICE_TYPES.IOS;
    }
    if (ANDROID_REGEX.test(navigator.userAgent)) {
      return DEVICE_TYPES.ANDROID;
    }
  }
  return null;
};
const LANDSCAPE_QUERY = '(orientation: landscape)';
const DEBOUNCE_MS = 100;
function getIsLandscape(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia(LANDSCAPE_QUERY).matches;
}
export const useIsMobileLandscape = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getCurrentDevice();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const deviceType = t0 as DEVICE_TYPES;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [DEVICE_TYPES.ANDROID, DEVICE_TYPES.IOS];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isMobileDevice = t1.includes(deviceType);
  const [isLandscape, setIsLandscape] = useState(getIsLandscape);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const update = function update() {
        setIsLandscape(getIsLandscape());
      };
      const debouncedUpdate = debounce(update, DEBOUNCE_MS);
      window.addEventListener("resize", debouncedUpdate);
      window.addEventListener("orientationchange", debouncedUpdate);
      return () => {
        window.removeEventListener("resize", debouncedUpdate);
        window.removeEventListener("orientationchange", debouncedUpdate);
        debouncedUpdate.cancel();
      };
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  return isLandscape && isMobileDevice;
};